/**
 * @generated SignedSource<<2351d9fb0c3a5979d08b40a9edf7d5cc>>
 * @relayHash 48f460f9a520e4649db50746143b46e8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 1dae8263c97df61feb5e1293f8c201ed97ae6a18cd190646b7af3ac5ce3699e2

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { uiAdminPagesFieldsQuery } from './uiAdminPagesFieldsQuery.graphql';

const node: PreloadableConcreteRequest<uiAdminPagesFieldsQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "1dae8263c97df61feb5e1293f8c201ed97ae6a18cd190646b7af3ac5ce3699e2",
    "metadata": {},
    "name": "uiAdminPagesFieldsQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
